import type { MixedItemTag } from "@memorang/types";

const SKILL_TAG_TYPE = "skill";
const QUESTION_TYPE_TAG_TYPE = "question type";
const PROFICIENCY_TAG_TYPE = "proficiency";

export const isSkillTag = (tag: MixedItemTag) => {
	return tag.type.toLowerCase() === SKILL_TAG_TYPE;
};

export const isQuestionTypeTag = (tag: MixedItemTag) => {
	return tag.type.toLowerCase() === QUESTION_TYPE_TAG_TYPE;
};

export const isProficiencyTag = (tag: MixedItemTag) => {
	return tag.type.toLowerCase() === PROFICIENCY_TAG_TYPE;
};

export const compareTagSortOrder = (a: MixedItemTag, b: MixedItemTag) => {
	const sortOrderDiff =
		(a.sortOrder ?? Number.MAX_SAFE_INTEGER) -
		(b.sortOrder ?? Number.MAX_SAFE_INTEGER);

	if (sortOrderDiff !== 0) {
		return sortOrderDiff;
	}

	const titleDiff = a.title.localeCompare(b.title);
	if (titleDiff !== 0) {
		return titleDiff;
	}

	return a.id - b.id;
};

export const sortTagsBySortOrder = (tags: MixedItemTag[]): MixedItemTag[] =>
	[...tags]
		.sort(compareTagSortOrder)
		.map((tag) =>
			tag.children
				? { ...tag, children: sortTagsBySortOrder(tag.children) }
				: tag,
		);
